export const posts = [
    {
      id: 1,
      title: '인공지능 기초 학습 가이드',
      content: '인공지능 학습을 시작하는 분들을 위한 완벽 가이드...',
      date: '2025-02-19',
      image: 'https://public.readdy.ai/ai/img_res/c22ebfe39e631e808ad948c508839779.jpg'
    },
    // ...
  ];
  
  export const boardItems = [
    {
      id: 1,
      title: '신규 프로젝트 진행 현황 보고',
      content: '2025년 1분기 신규 프로젝트의 진행 상황...',
      author: '김지원',
      updatedAt: '2025-02-19'
    },
    // ...
  ];
  